import React from 'react';
import './Cali.css'; 

const Leticia = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKLT.pdf" target="_blank" rel="noreferrer">Aeropuerto Alfredo Vasquez Cobo</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 03</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3B.pdf" target="_blank" rel="noreferrer">BODA3B</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3B.pdf" target="_blank" rel="noreferrer">DALO3B</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3B.pdf" target="_blank" rel="noreferrer">MEXA2A</a></th>
          </tr>        
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3E.pdf" target="_blank" rel="noreferrer">AROT3E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3E.pdf" target="_blank" rel="noreferrer">KALO3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3E.pdf" target="_blank" rel="noreferrer">MIKO3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3E.pdf" target="_blank" rel="noreferrer">ROKU3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BUTA2L.pdf" target="_blank" rel="noreferrer">BUTA2L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BUTA2L.pdf" target="_blank" rel="noreferrer">SPRI3C</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 21</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">BODA3C</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">BUTA2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">DALO3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">KALO2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">MEXA2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BODA3C.pdf" target="_blank" rel="noreferrer">SPRI2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">AROT3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">KALO3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">MIKO3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">ROKU3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">SPRI1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3D.pdf" target="_blank" rel="noreferrer">BUTA1M</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 03</th>                      
          </tr>
          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 21</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/DALO2D.pdf" target="_blank" rel="noreferrer">DALO2D</a></th>
          </tr>       
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/DALO2D.pdf" target="_blank" rel="noreferrer">BODA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/PABO1A.pdf" target="_blank" rel="noreferrer">PABO1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/PABO1A.pdf" target="_blank" rel="noreferrer">ROKU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3C.pdf" target="_blank" rel="noreferrer">AROT3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/AROT3C.pdf" target="_blank" rel="noreferrer">KALO3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BUTA2J.pdf" target="_blank" rel="noreferrer">BUTA2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/BUTA2J.pdf" target="_blank" rel="noreferrer">SPRI3A</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 03</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/VOR03.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 21</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/VOR21.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLT/RNP21.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Leticia;